import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { CustomerAccountHeaderLoaderProps } from '../../types';

export const CustomerAccountHeaderLoader = ({
  size
}: CustomerAccountHeaderLoaderProps) => {
  return (
    <>
      <div>
        <CatSkeleton size={size} width="129px" />
      </div>
      <div>
        <div className="d-flex justify-content-around">
          <div className="pe-lg-3 pe-md-3">
            <CatSkeleton size={size} width="93px" />
          </div>
          <div className="pe-2 d-none d-md-block d-lg-block">
            <CatSkeleton size={size} width="20px" />
          </div>
          <div className="pe-4 d-none d-md-block d-lg-block">
            <CatSkeleton size={size} width="20px" />
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerAccountHeaderLoader;
